var map = {
	"./countries-2025": 5338,
	"./countries-2025.json": 5338,
	"./countries-info": 3113,
	"./countries-info.json": 3113,
	"./countries-tac": 119,
	"./countries-tac.json": 119,
	"./countries-versions": 9460,
	"./countries-versions.json": 9460,
	"./i18n": 132,
	"./i18n.json": 132,
	"./languages": 3411,
	"./languages.json": 3411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;